var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "productContainer" }, [
    _c("div", { staticClass: "productImage" }, [
      _c(
        "a",
        {
          attrs: {
            href: _vm.$root.pointshop
              ? _vm.basedir +
                _vm.$root.pointshopUrlPrefix +
                _vm.product.productPageLink
              : _vm.basedir + "/" + _vm.product.productPageLink,
          },
        },
        [
          _c("v-lazy-image", {
            attrs: {
              alt: _vm.product.name,
              "src-placeholder": _vm.product.imageUrl,
              srcset: _vm.imageSet.set,
              src: _vm.editing
                ? `${_vm.newImageUrl}?w=${_vm.imageSize}`
                : _vm.product.imageUrl + "?w=" + _vm.imageSize,
              size: _vm.imageSet.size,
            },
            on: { error: _vm.handleImageError },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "productInfo" },
      [
        _c(
          "a",
          {
            attrs: {
              href: _vm.$root.pointshop
                ? _vm.basedir +
                  _vm.$root.pointshopUrlPrefix +
                  _vm.product.productPageLink
                : _vm.basedir + "/" + _vm.product.productPageLink,
            },
          },
          [
            _c("h3", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.editing ? _vm.editData.name : _vm.product.name
                ),
              },
            }),
          ]
        ),
        _vm.hasPromotion
          ? _c("PromotionLabel", {
              attrs: { promotion: _vm.filteredPromotion },
            })
          : _vm._e(),
        this.$root.admin && _vm.view == "list"
          ? _c(
              "div",
              { staticStyle: { float: "right" } },
              [
                _c("transition", { attrs: { name: "bounce" } }, [
                  !_vm.editing
                    ? _c(
                        "button",
                        {
                          staticClass: "edit btn",
                          on: {
                            click: function ($event) {
                              _vm.editing = true
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-pencil",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v("Edit"),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _vm._e(),
        _c("span", {
          staticClass: "productText",
          domProps: {
            innerHTML: _vm._s(
              _vm.editing ? _vm.editData.description : _vm.product.description
            ),
          },
        }),
        this.$root.admin && _vm.view == "list"
          ? _c(
              "div",
              [
                _c(
                  "transition",
                  { attrs: { name: "bounce" } },
                  [
                    _vm.editing
                      ? _c("productEdit", {
                          attrs: {
                            productData: _vm.product,
                            productName: _vm.editData.name,
                            contentID: _vm.product.WCMS_WebPageContent_ID,
                            edit: _vm.product.edit,
                            desc: _vm.editData.description,
                            imgUrl: _vm.product.imageUrl,
                          },
                          on: {
                            updateProductWithNewData:
                              _vm.updateProductWithNewData,
                            updateProduct: _vm.updateProduct,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "infoContainer" }, [
          _c("a", {
            staticClass: "readMoreProductLink",
            attrs: {
              href: _vm.$root.pointshop
                ? _vm.basedir +
                  _vm.$root.pointshopUrlPrefix +
                  _vm.product.productPageLink
                : _vm.basedir + "/" + _vm.product.productPageLink,
            },
            domProps: { innerHTML: _vm._s(_vm.$root.language.wsm_MoreInfo) },
          }),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "buyBtnWrapper" },
      _vm._l(_vm.product.products, function (subProd, index) {
        return _c(
          "div",
          {
            key: index,
            class: [
              _vm.showBuyButtonLogic ? "shop" : "nonShop",
              parseInt(subProd.discount) > 0 || subProd.taxRateFactor == 1
                ? "extraHeight"
                : "",
              "productActionBar",
              _vm.$store.state.BasketLines.find(
                (x) => x.id == subProd.productId
              ) &&
              !_vm.$store.state.BasketLines.find(
                (x) => x.id == subProd.productId
              ).isSubscription &&
              _vm.$store.state.BasketLines.find(
                (x) => x.id == subProd.productId
              ) &&
              _vm.$store.state.BasketLines.find(
                (x) => x.id == subProd.productId
              ).quantity > 0 &&
              _vm.$root.subscriptionenabled
                ? "extraPadding"
                : "",
            ],
          },
          [
            _c(
              "div",
              { staticClass: "infoWrapper" },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.$root.pointshop
                        ? _vm.basedir +
                          _vm.$root.pointshopUrlPrefix +
                          subProd.productPageLink
                        : _vm.basedir +
                          "/" +
                          subProd.productPageLink +
                          (_vm.$root.subscriptionenabled
                            ? "#variant=" + subProd.productId
                            : ""),
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "quantityProduct",
                      domProps: { innerHTML: _vm._s(subProd.quantityString) },
                    }),
                  ]
                ),
                subProd.availability != 2 && _vm.onlyBuyWhenLoggedInCheck
                  ? _c("p", {
                      staticClass: "productPrice",
                      domProps: {
                        innerHTML: _vm._s(_vm.getVisString(subProd.price)),
                      },
                    })
                  : _vm._e(),
                ((_vm.view == "grid" &&
                  (subProd.discount > 0 || _vm.$root.display.iscompany)) ||
                  _vm.view == "list") &&
                !_vm.$root.pointshop
                  ? _c("additionalInfo", {
                      attrs: {
                        data: subProd,
                        companyPriceIncludingVat: _vm.getVisString(
                          subProd.companyPriceIncludingVat
                        ),
                        listPrice: _vm.getVisString(subProd.listPrice),
                        localDiscount: _vm.getVisString(subProd.discount),
                        tax: subProd.taxRateFactor,
                        showBuyButton: _vm.showBuyButtonLogic,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            (_vm.$root.admin || _vm.$root.localadmin) && _vm.view == "list"
              ? _c("inventoryManagement", {
                  attrs: { name: subProd.name, id: subProd.productId },
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "buttonAndInfoWrapper" },
              [
                _vm.view == "list" || (_vm.view == "list" && _vm.mobile)
                  ? _c(
                      "a",
                      {
                        staticClass: "infoLink",
                        attrs: {
                          href: _vm.$root.pointshop
                            ? _vm.basedir +
                              _vm.$root.pointshopUrlPrefix +
                              subProd.productPageLink
                            : _vm.basedir + "/" + subProd.productPageLink,
                        },
                      },
                      [_vm._m(0, true)]
                    )
                  : _vm._e(),
                _vm.showBuyButtonLogic
                  ? _c("addToBasket", {
                      ref: "addToBasketBtn" + subProd.productId,
                      refInFor: true,
                      class: [
                        "addToBasketButton",
                        subProd.availability == 2 ? "nosale" : "",
                        _vm.$root.admin ? "adminBtn" : "",
                      ],
                      attrs: {
                        isSubscriptionInBasket:
                          _vm.isSubscriptionInBasket(subProd),
                        id: subProd.productId,
                        quantity: _vm.quantity,
                        availability: subProd.availability,
                        backorder: subProd.isBackorderAllowed,
                        preorder: subProd.isPreorderAllowed,
                        productname: subProd.name,
                        price: subProd.price,
                      },
                      on: { gtag: _vm.gtag },
                    })
                  : _vm._e(),
                _vm.view == "grid" || (_vm.view == "grid" && _vm.mobile)
                  ? _c(
                      "a",
                      {
                        staticClass: "infoLink",
                        attrs: {
                          href: _vm.$root.pointshop
                            ? _vm.basedir +
                              _vm.$root.pointshopUrlPrefix +
                              subProd.productPageLink
                            : _vm.basedir + "/" + subProd.productPageLink,
                        },
                      },
                      [_vm._m(1, true)]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.$store.state.BasketLines.find(
              (x) => x.id == subProd.productId
            ) &&
            !_vm.$store.state.BasketLines.find((x) => x.id == subProd.productId)
              .isSubscription &&
            _vm.$store.state.BasketLines.find(
              (x) => x.id == subProd.productId
            ) &&
            _vm.$store.state.BasketLines.find((x) => x.id == subProd.productId)
              .quantity > 0 &&
            _vm.$root.subscriptionenabled &&
            subProd.isAllowSubscription &&
            !_vm.$root.pointshop
              ? _c(
                  "a",
                  {
                    staticClass: "savewithautoship",
                    style: `${
                      _vm.view == "list" &&
                      !_vm.mobile &&
                      (subProd.discount > 0 || _vm.$root.display.iscompany) &&
                      !_vm.$root.pointshop
                        ? ""
                        : ""
                    }`,
                    attrs: {
                      href: _vm.$root.pointshop
                        ? _vm.basedir +
                          _vm.$root.pointshopUrlPrefix +
                          _vm.product.productPageLink
                        : _vm.basedir +
                          "/" +
                          _vm.product.productPageLink +
                          "#variant=" +
                          subProd.productId +
                          "&savewithsub=true",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$store.state.BasketLines.find(
                          (x) => x.id == subProd.productId
                        ) &&
                          _vm.$store.state.BasketLines.find(
                            (x) => x.id == subProd.productId
                          ).isSubscription
                          ? ""
                          : _vm.$root.language.wsm_sub_subavailable
                      )
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "infoBtn" }, [
      _c("i", { staticClass: "fa fa-info" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "infoBtn" }, [
      _c("i", { staticClass: "fa fa-info" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }